module.exports = __webpack_public_path__ + "media/images/icon__twitter-1d0344d381ff0442bccac157ec4d77ae.png";